<template>
<div
    v-if="profile != null"
>

    <p>These are the hours that you, {{profile.employee_label}}, are available.</p>
    <p>If you need to quickly jump into Do Not Disturb for a certain period of time (e.g. 30 minutes) <a v-on:click="onClickAdHocDND" style="text-decoration: underline">click here to setup ad-hoc do not disturb hours</a></p>
    
    <m-edit-message-patterns-compact
        label="Auto reply when not available"
        v-model="profile.employee_account.dnd_settings.dnd_auto_response_message_patterns"
        context="dnd-auto-response"
        style="margin-bottom: 15px"
        disabled
    />

    Monday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.monday.available_intervals"
            disabled
        />
    
    Tuesday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.tuesday.available_intervals"
            disabled
        />
    
    Wednesday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.wednesday.available_intervals"
            disabled
        />

    Thursday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.thursday.available_intervals"
            disabled
        />

    Friday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.friday.available_intervals"
            disabled
        />
    
    Saturday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.saturday.available_intervals"
            disabled
        />
    
    Sunday
        <m-dnd-intervals
            v-model="profile.employee_account.dnd_settings.sunday.available_intervals"
            disabled
        />

    <div
        v-for="(custom_dnd,index) in profile.employee_account.dnd_settings.custom_dnd_settings"
        :key="index"
    >
        {{prettyDateRange(custom_dnd)}}
        <m-dnd-intervals
            v-model="custom_dnd.available_intervals"
            :dnd_auto_response="custom_dnd.dnd_auto_response"
            disabled
        />
    </div>

    <div 
        style="text-align: right; margin-top: 5px;"
        v-show="can_write"
    >
        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="onEditNotifications"
        >
            <v-icon dark> mdi-lead-pencil</v-icon>
        </v-btn>
    </div>

     <m-edit-dnd-dialog
        ref="edit_dnd_dialog"
        v-on:ok="onPatchEmployeeAccount"
    />

    <m-ad-hoc-dnd-dialog
        ref="ad_hoc_dnd_dialog"
        v-on:update_dnd="doUpsertAdHocDND($event)"
        v-on:exit_ad_hoc_dnd="doExitAdHocDND($event)"
    />

</div>
</template>

<script>

const Validation = require('@/js/validate.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: {

        onEditNotifications()
        {
            this.$refs['edit_dnd_dialog'].showDialog(this.profile);
        },

        onPatchEmployeeAccount(changes)
        {
            this.$emit('patch-employee-account',changes);
        },

        prettyDateRange(custom_dnd)
        {
            if (custom_dnd.start_date == custom_dnd.stop_date)
                return custom_dnd.start_date;
            
            return custom_dnd.start_date+" thru "+custom_dnd.stop_date;
        },

        doExitAdHocDND(info)
        {
            this.$rc.exitAdHocDND(
                info
            );
        },
        
        doUpsertAdHocDND(ad_hoc_dnd_info)
        {
            this.$rc.putAdHocDND(
                ad_hoc_dnd_info,
            );
        },

        onClickAdHocDND()
        {
            this.$rc.getAdHocDND(
                this.$rc.$state.employee_id,
                (data) => {
                    this.$refs['ad_hoc_dnd_dialog'].showDialog(
                        this.$rc.$state.organization_id,
                        this.$rc.$state.employee_id,
                        data.ad_hoc_dnd);
                },
                () => {
                    this.$rc.alert(
                        "Internal Failure",
                        "Failed to retrieve Quick DND Settings"
                    );
                }
            );  
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

        alert_sound_label() 
        {

            let ret = this.profile.extended_data.alert_sound_label;

            if ( ret == null )
                ret = 'No sound will play';

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>